import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: null
}

// getters
const getters = {
  getPenawaranJalurAktif: state => state.all
}

// actions
const actions = {
  getPenawaranJalurAktif ({ commit }) {
    api.get('/v2/penawaran_jalur/aktif')
      .then(response => {
        let responseData = response.data
        commit(types.PENAWARAN_JALUR_AKTIF_RECEIVE, responseData.data)
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.PENAWARAN_JALUR_AKTIF_RECEIVE] (state, response) {
    state.all = response
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/penawaran-jalur-aktif.js